import { selectActiveAccount } from '@epicuro-next/state/accounts-state';
import { selectPresetDisplayName } from '@epicuro-next/state/p-basket-state';
import { selectUrl } from '@epicuro-next/state/router-store';
import { selectUser } from '@epicuro-next/state/user-state';
import { Store } from '@ngrx/store';

export function defaultCollectorSelect(store: Store) {
  return [
    store.select(selectActiveAccount),
    store.select(selectPresetDisplayName),
    store.select(selectUrl),
    store.select(selectUser),
  ];
}
